import { SxProps, Theme } from "@mui/material";

export const dialogPaperStyles: SxProps<Theme> = (theme) => ({
  borderRadius: "18px",
  overflow: "hidden",
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  width: "100%",
  maxWidth: { xs: "320px", sm: "360px" },
});

export const dialogTitleStyles: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: "18px",
  fontFamily: "Red Hat Display",
  px: 2.5,
  pt: 2.5,
  pb: 1,
};

export const dialogContentStyles: SxProps<Theme> = {
  px: 2.5,
  pb: 2.5,
  pt: 0,
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  overflowX: "hidden",
};

export const optionStyles = (isSelected: boolean): SxProps<Theme> => (theme) => ({
  border: "1px solid",
  borderColor: isSelected
    ? theme.palette.primary.main
    : theme.palette.divider,
  borderRadius: "12px",
  px: 1.5,
  py: 1.25,
  cursor: "pointer",
  bgcolor: isSelected ? theme.palette.action.selected : "transparent",
  transition: "border-color 0.2s, background-color 0.2s",
  display: "flex",
  alignItems: "center",
  gap: 1,
  minWidth: 0,
  overflow: "hidden",
  "&:hover": {
    borderColor: isSelected
      ? theme.palette.primary.main
      : theme.palette.action.hover,
    bgcolor: isSelected
      ? theme.palette.action.selected
      : theme.palette.action.hover,
  },
});

export const optionTitleStyles: SxProps<Theme> = (theme) => ({
  fontWeight: 600,
  fontSize: "15px",
  fontFamily: "Red Hat Display",
  color: theme.palette.text.primary,
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const goButtonStyles: SxProps<Theme> = (theme) => ({
  mt: 0.5,
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 600,
  fontFamily: "Red Hat Display",
  py: 1,
  color: "#FFFFFF",
  backgroundColor: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    color: "#FFFFFF",
  },
  "&.Mui-disabled": {
    color: "#FFFFFF",
  },
});

export const errorTextStyles: SxProps<Theme> = {
  fontSize: "13px",
  color: "error.main",
};
